import React from 'react';

import AccountInfo from './AccountInfo';
import SellerRemittanceInfo from './SellerRemittanceInfo';
import BuyerPaymentInfo from './BuyerPaymentInfo';
import Membership from './Membership';

export default ({ props, setFieldValue, callBackFun, nextCallBack, pageLanguageContents, uploadDriverLisence, setTaxIdState }) => {

  return (
    <>
      <AccountInfo
        props={props}
        setFieldValue={setFieldValue}
        callBackFun={callBackFun}
        nextCallBack={nextCallBack}
        pageLanguageContents={pageLanguageContents}
      />

      {/* Buyer payment information component */}
      {(props.values.reseller === "active" || (props.values.buyerSellerOption === "Buyer" || props.values.buyerSellerOption === "Buyer & Seller")) && (
        <BuyerPaymentInfo
          props={props}
          setFieldValue={setFieldValue}
          pageLanguageContents={pageLanguageContents}
        />
      )}

      {/* Seler remittance information component */}
      {((props.values.reseller === "active") || (props.values.buyerSellerOption === "Buyer & Seller" || props.values.buyerSellerOption === "Seller")) && (
        <SellerRemittanceInfo
          setFieldValue={setFieldValue}
          props={props}
          uploadDriverLisence={uploadDriverLisence}
          setTaxIdState={setTaxIdState}
          pageLanguageContents={pageLanguageContents}
        />
      )}

      {/* Membership payment information component  */}
      <Membership
        setFieldValue={setFieldValue}
        props={props}
        pageLanguageContents={pageLanguageContents}
      />
    </>
  );
};
